import { APIcallerv2 } from './APIcaller';

const BASE = `/translations`;

const getTranslationsProgress = () => APIcallerv2.apiGet(`${BASE}/progress`);

const getTranslationsTemplate = () => APIcallerv2.apiGet(`${BASE}/template`, {}, 'blob');

const validateBatchUpdateImportTemplate = (payload) =>
  APIcallerv2.apiPost(`${BASE}/template/validate`, payload);

const importTranslations = (payload) => APIcallerv2.apiPost(`${BASE}/import`, payload);

export default {
  getTranslationsProgress,
  getTranslationsTemplate,
  validateBatchUpdateImportTemplate,
  importTranslations,
};
